import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Select, Option } from 'barnyard/components';

const TimeOperatorSelect = ({
  operators, value, onChange, ...other
}) => (
  <Select
    optionFilterProp='name'
    useNative={false}
    value={value}
    onChange={onChange}
    {...other}
  >
    {_.map(operators, (val, key) => (
      <Option name={val} value={val} key={key}>{val}</Option>
    ))}
  </Select>
);


TimeOperatorSelect.propTypes = {
  operators: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default TimeOperatorSelect;
